export default __webpack_public_path__ + "static/media/balmain-1.064a7c90.jpg";